// unit: filter3
import f from "../../../../funcs";
import Operator from "./Operator";


let NoRows = Operator.extend("NoRows", {
    literal: ["noRows"],

    validateValue(value) {
        return f.isString(value) && value.trim().toLowerCase() === "norows";
    },

    compile2js() {
        return "false";
    }
});

export default NoRows;
